let counter = 0

export default (prefix = 'id') => {
	counter += 1
	return `${prefix}${counter}`
}
